'use client';

import { useGoogleAnalytics } from '@/lib/analytics';
import { Suspense } from 'react';

function GoogleAnalyticsComponent() {
  useGoogleAnalytics();
  return null;
}

export default function GoogleAnalytics() {
  return (
    <Suspense fallback={null}>
      <GoogleAnalyticsComponent data-component-id="src/components/GoogleAnalytics.tsx:14:6" data-component-path="src/components/GoogleAnalytics.tsx" data-component-line="14" data-component-end-line="14" data-component-file="GoogleAnalytics.tsx" data-component-name="GoogleAnalyticsComponent" data-component-content="%7B%22elementName%22%3A%22GoogleAnalyticsComponent%22%7D" />
    </Suspense>
  );
}